import type { FC } from 'react';
import HeroContent from './HeroContent';

interface HeroSectionProps {
  slogan: string;
}

const HeroSection: FC<HeroSectionProps> = ({ slogan }) => {
  return (
    <section className="relative w-full bg-[#dddddd] h-[200px] bg-[url('/assets/isbirligi-bg.webp')] bg-cover md:bg-contain bg-no-repeat bg-left-top">
      <HeroContent slogan={slogan} />
    </section>
  );
};

export default HeroSection;